import React, { useEffect, useRef, useState } from 'react';
import styles from './Checkbox.module.scss';
import { Checkbox as CheckboxBase } from 'uiKit/atoms/Checkbox/Checkbox'
import { FormControlLabel } from 'uiKit/atoms/FormControlLabel/FormControlLabel';

export const Checkbox = ({ id, isChecked, value, label, onChange }) => {
  const checkBox = useRef();
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    setChecked(isChecked);
  }, [isChecked]);

  const onClick = () => {
    setChecked(!checked);
    onChange([{ name: value, value: !checked }]);
  };

  return (
    <>
      <FormControlLabel
        sx={{
          '& .MuiFormControlLabel-label': {
            color: 'white',
          },
        }}
        htmlFor={id}
        className={styles.checkbox}
        onClick={onClick}
        label={label} 
        control={<CheckboxBase ref={checkBox} checked={checked} value={value} />} />
    
    </>
  );
};
